import { Skeleton } from '@mui/material';

export const MessageCardSkeleton = ({ variant = 'normal' }) => {
	return (
		<div
			className={`flex md:block ${variant == 'normal'
					? 'justify-center'
					: 'w-full max-w-[270px] min-w-[270px]'
				} mb-3`}
		>
			<div className='relative w-[268px]'>
				<div className='w-full mx-auto rounded-[24px] border-2 border-gray-200 bg-white shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] min-h-[550px]'>
					{/* Header skeleton */}
					<div className='border-b-2 border-gray-100 pt-[13px] pb-[13px]'>
						<div className='flex flex-col items-center justify-center'>
							<Skeleton
								variant='circular'
								width={60}
								height={60}
								sx={{ mb: 1 }}
							/>
							<Skeleton
								variant='text'
								width={120}
								height={24}
								sx={{ fontSize: '1rem' }}
							/>
						</div>
					</div>

					{/* Content skeleton */}
					<div className='p-[19px] h-[436px] overflow-y-auto'>
						{/* Image skeleton */}
						<div className='mb-2'>
							<Skeleton
								variant='rectangular'
								width='85%'
								height={200}
								sx={{ borderRadius: '10px', mb: 2 }}
							/>
						</div>

						{/* Text content skeleton */}
						<div className='rounded-[10px] bg-gray-100 p-1 md:p-2'>
							<Skeleton
								variant='text'
								width='100%'
								height={20}
								sx={{ mb: 1 }}
							/>
							<Skeleton
								variant='text'
								width='90%'
								height={20}
								sx={{ mb: 1 }}
							/>
							<Skeleton
								variant='text'
								width='75%'
								height={20}
								sx={{ mb: 1 }}
							/>
							<Skeleton
								variant='text'
								width='60%'
								height={20}
							/>
						</div>
					</div>
				</div>

				{/* Footer skeleton */}
				<div className='flex flex-col items-center justify-center max-w-[268px] mx-auto relative'>
					<Skeleton
						variant='text'
						width={100}
						height={32}
						sx={{ mt: 1, mb: 0 }}
					/>
					<div className='mt-[-20px] flex justify-center'>
						<Skeleton
							variant='text'
							width={120}
							height={24}
						/>
						<div className='mt-[-20px] flex justify-end cursor-pointer absolute right-40'>
							<Skeleton
								variant='circular'
								width={24}
								height={24}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
